import React from 'react';
import { Page } from '../Page';
import { Logo } from '../Logo';
export function Page12() {
  return <Page hideFooter variant="dark" data-id="element-782" data-mp="2dnin27qjsr5c">
      <div className="flex-1 flex items-center justify-center" data-id="element-783" data-mp="2dotzevy27782">
        <Logo className="w-[230px] h-[230px] object-contain opacity-90" data-id="element-784" data-mp="2in5atb405pse" />
      </div>
    </Page>;
}